/*
 * @Author: your name
 * @Date: 2020-08-21 11:47:37
 * @LastEditTime: 2020-10-10 10:56:30
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath     : \vue-gaokao-ebook\src\store\store.js
 */
import Vue from 'vue';
import Vuex from 'vuex';
// import state from './state.js';
// import getters from './getters.js';
// import mutations from './mutations.js';
// import actions from './actions.js';

Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        isShowLogin: false,//是否显示登录弹窗
        userInfo: {},//用户信息
        tabType: 'home',  // 智能统练 'home'   专家测评 'expert'
        fontSize: 24,
        paper_data: {},
        audioPlayId: null,
        activeIndex:0
    },
    mutations: {
        changeIsShowLogin(state, param) { //改变登录状态
            state.isShowLogin = param;
        },
        updateUserInfo(state, param){//更新userinfo
            state.userInfo = param;
        },
        setTabType(state, param){ //设置切换
            state.tabType = param;
        },
        setfontSize(state, param) {
            state.fontSize = param;
        },
        setPaperData(state, param) {
            state.paper_data = param;
        },
        setAudioPlayId(state, param) {
          state.audioPlayId = param;
        },
        setActiveIndex(state,param){
           state.activeIndex = param
        },
        
    },
    actions: {
        selectTabType(context, param){
            context.commit('setTabType', param);
        },
        setFontSize(context, param){
            context.commit('setfontSize', param);
        },
        actionsSetPaperData(context, param){
          context.commit('setPaperData', param);
        },
        actionsSetAudioPlayId(context, param){
          context.commit('setAudioPlayId', param);
        }
    },
    getters: {
        getUserInfo : (state) => {
            let info = state.userInfo;
            console.log("gett => " , info)
            if (info == null || !info.id) {
                let localInfo = window.localStorage.getItem('userinfo');
                if (localInfo != null) {
                    state.userInfo = JSON.parse(localInfo);
                    return state.userInfo;
                }else{
                    return {}
                }
            } else {
                return info;
            }
        },
        getBeforeGaoKaoDay(state) {
            let gaokao_year;
            var now = new Date();
            var current_year = String(now.getFullYear());
            var this_year_gaokao = new Date(parseInt(current_year), 6 - 1, 7);
            var stamp_now = now.getTime();
            var stamp_this_year_gaokao = this_year_gaokao.getTime();
            if (stamp_this_year_gaokao - stamp_now > 0) {
                gaokao_year = current_year;
            } else {    
                gaokao_year = String(parseInt(current_year) + 1);
            }
            let isLogin = window.localStorage.getItem("isLogin");
            let userInfo = state.userInfo;
            if(userInfo.examYear != undefined && userInfo.examYear != null){
                gaokao_year = userInfo.examYear;
            }
            let gaoKaoDay = new Date(gaokao_year,6-1,7);
            return gaoKaoDay
        },
        getGaoKaoYear(state){
            let gaokao_year;
            var now = new Date();
            var current_year = String(now.getFullYear());
            var this_year_gaokao = new Date(parseInt(current_year), 6 - 1, 7);
            var stamp_now = now.getTime();
            var stamp_this_year_gaokao = this_year_gaokao.getTime();
            if (stamp_this_year_gaokao - stamp_now > 0) {
                gaokao_year = current_year;
            } else {    
                gaokao_year = String(parseInt(current_year) + 1);
            }
            let isLogin = window.localStorage.getItem("isLogin");
            let userInfo = state.userInfo;
            if(userInfo.examYear != undefined && userInfo.examYear != null){
                gaokao_year = userInfo.examYear;
            }
            
            
            return gaokao_year;
        }
    }
})

